import types from './types';

const setSession = (session) => ({
  type: types.SET,
  session,
});

export default {
  setSession,
};
